import {wwData$} from '@px/streams/worker-data';
import {filter, map, shareReplay} from 'rxjs/operators';
import Msg = ww.Msg;

export const spotMarketRealtime$ = wwData$.pipe(
  filter((o: Msg<any>) => o.type === 'market24h-spot-realtime'),
  map((o: Msg<any>): ContractMarket => o.data),
  shareReplay(1)
);
